import UserService from "@/services/userService";
import SentryService from "@/services/sentryService";
import Vue from "vue";

export async function refreshSupplierFactoring() {
  const token = localStorage.getItem("token");
  const userRaw = localStorage.getItem("user");
  let user = null;

  if (!token || !userRaw) return;

  try {
    user = JSON.parse(userRaw);
  } catch (e) {
    SentryService.captureError(e, {
      context: "refreshSupplierFactoring",
      message: "Error parsing user",
    });
    return;
  }

  // Additional check: ensure user is not null after parsing
  if (!user) {
    return;
  }

  const isSupplier =
    user?.role_name === "admin-supplier" ||
    user?.role_name === "vendor-supplier";
  const needsFactoring = isSupplier && user?.use_factoring && !user?.factoring;

  if (!needsFactoring) return;

  try {
    const res = await UserService.getUser({ refresh: true });
    const result = await res.json();

    if (res.status === 200) {
      localStorage.setItem("user", JSON.stringify(result));

      // Use Vue.prototype to access $UserManager
      Vue.prototype.$UserManager.store(result);
    }
  } catch (err) {
    SentryService.captureError(err, {
      context: "refreshSupplierFactoring",
      message: "Error updating user factoring",
    });
  }
}
